<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center title">
        <v-btn text href="/elements">Inventaire</v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-btn text to="/elements" :ripple="false">Éléments</v-btn>
      <v-btn text to="/search" :ripple="false">Recherche avancée</v-btn>
      <v-btn text to="/groups" :ripple="false">Groupes</v-btn>
      <v-btn text to="/params" :ripple="false">Paramètres</v-btn>
      <user-profile />
    </v-app-bar>
    <v-content>
      <router-view
        :categories="categories"
        :costCenters="costCenters"
        :entities="entities"
        :inventoryDeletionCauses="inventoryDeletionCauses"
        :places="places"
        :admin="admin"
        :updateParam="updateParam"
        :deleteParam="deleteParam"
        :latest="latest"
      />
    </v-content>
  </v-app>
</template>

<script>
import UserProfile from "@/components/UserProfile";
import axios from "axios";

export default {
  components: {
    UserProfile,
  },
  data: () => ({
    params: [
      "categories",
      "cost-centers",
      "entities",
      "inventory-deletion-causes",
      "places",
    ],
    categories: undefined,
    costCenters: undefined,
    entities: undefined,
    inventoryDeletionCauses: undefined,
    places: undefined,
    admin: false,
    latest: undefined,
  }),
  async mounted() {
    this.admin = this.$keycloak.hasResourceRole(
      "write",
      process.env.VUE_APP_KC_CLIENT_ID
    );
    try {
      const promises = this.params.map((param) =>
        axios({
          method: "get",
          url: `${process.env.VUE_APP_API_URI}/${param}`,
        })
      );
      const { data: latest } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/latest-element`,
      });
      this.latest = latest;
      const [
        { data: categories },
        { data: costCenters },
        { data: entities },
        { data: inventoryDeletionCauses },
        { data: places },
      ] = await Promise.all(promises);
      this.categories = categories;
      this.costCenters = costCenters;
      this.entities = entities;
      this.inventoryDeletionCauses = inventoryDeletionCauses;
      this.places = places;
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    updateParam: function (type, payload) {
      if (type === "entities") {
        payload.costCenter = this.costCenters.find(
          (c) => c._id === payload.costCenter
        );
      }
      if (this[type].find((t) => t._id === payload._id)) {
        Object.assign(
          this[type].find((t) => t._id === payload._id),
          payload
        );
      } else {
        this[type].push(payload);
        this[type] = this[type].sort((a, b) => a.name.localeCompare(b.name));
      }
    },
    deleteParam: function (type, _id) {
      this[type] = this[type].filter((t) => t._id !== _id);
    },
  },
};
</script>
